import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  adyenCallbackUrl: () => getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/adyen_classic"),
  adyenRedirectCallbackUrl: () => getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/adyen_classic/redirect"),
  zipRedirectCallbackUrl: () => getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/zip/redirect"),
  paymentsBaseUrl: () => getUrlForEnv(services.PAYMENTS_V2_SERVICE, "")
}

export default endpoints
